import { render, staticRenderFns } from "./ABMRevendedores.vue?vue&type=template&id=168c6324&scoped=true"
import script from "./ABMRevendedores.vue?vue&type=script&lang=js"
export * from "./ABMRevendedores.vue?vue&type=script&lang=js"
import style0 from "./ABMRevendedores.vue?vue&type=style&index=0&id=168c6324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c6324",
  null
  
)

export default component.exports